module.exports = __webpack_public_path__ + "img/promo_box_2_bg.91084c5b.jpg";